<app-header></app-header>

<div class="tile is-ancestor" style="padding:10px;">

  <div class="tile is-parent is-vertical is-4">
    <app-logo></app-logo>
    <app-actions class="mt-4"></app-actions>
  </div>


  <app-shows class="is-flex is-flex-direction-row is-align-item-stretch"></app-shows>

</div>


